<template>
  <div class="check-login">
    <el-form ref="ruleForm" :model="form" :rules="rules">
      <el-form-item
        label="手机号"
        prop="phone"
        label-width="100px"
        :class="{'is-error': errMsg.length > 0}"
        :style="errMsg.length > 0 ? {'margin-bottom': 0} : {}"
      >
        <el-input v-model="form.phone" type="number" autocomplete="off" placeholder="请输入手机号"></el-input>
        <template v-if="errMsg.length > 0">
          <p v-for="msg in errMsg" :key="msg" class="error-message">{{ msg }}</p>
        </template>
      </el-form-item>
      <el-form-item
        class="passworld"
        label="验证码"
        prop="code"
        label-width="100px"
        :style="errMsg.length > 0 ? {'margin-top': 0} : {}"
      >
        <el-input v-model.trim="form.code" autocomplete="off" placeholder="请输入验证码"></el-input>
        <sendCodeBtn :phoneNum="form.phone" :errMsg.sync="errMsg" @beforeSend="handleBeforeSendCode"/>
      </el-form-item>
    </el-form>
    <p class="find-phone" @click="$emit('update:formType', 'findPhone')">找回报名手机号？</p>
  </div>
</template>

<script>
import {Dialog, FormItem, Form, Button, Input } from 'element-ui'
import { mapState, mapActions } from 'vuex';
import { mobileSmsLogin } from '@/services/user';
import sendCodeBtn from "./send-code-btn.vue"
export default {
  name: "check-login",
  components: {
    ElFormItem: FormItem,
    ElForm: Form,
    ElButton: Button,
    ElInput: Input,
    ElDialog: Dialog,
    sendCodeBtn
  },
  data() {
    const validateMobileNum = (rule, value, callback) => {
      this.errMsg = []
      if(!this.checkPhone(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback();
      }
    }
    const validateverifyCode = (rule, value, callback) => {
      if(!value) {
        callback(new Error('请输入验证码'))
      } else {
        callback();
      }
    }
    return {
      form: {
        phone: '',
        code: ''
      },
      isSend: false,
      sendTime: 59,
      sendTimer: null,
      rules: {
        phone: [
          { validator: validateMobileNum, trigger: ['blur', 'change'], required: true }
        ],
        code: [
          { validator: validateverifyCode, trigger: 'blur', required: true }
        ],
      },
      errMsg: []
    };
  },
  computed:{
    ...mapState({
      globalConfig: state => state.router.globalConfig,
      competitionId: state => state.router.id
    })
  },
  created() {},
  methods: {
    ...mapActions(['saveUserInfo']),
    submitForm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if(!valid) return;
        try {
          const loginRes = await mobileSmsLogin({
            mobile: this.form.phone + '',
            competitionId: this.competitionId,
            verifyCode: this.form.code + '',
            nocFlag: true
          })
          this.errMsg = [];
          this.saveUserInfo(loginRes.data)
          this.$emit('loginBoxHide')
        } catch(e){
          if(e && e.status == 403) {
            this.errMsg = ['当前手机号与NOC官网报名时的填写不一致', '请重新输入，否选手将无法参加比赛。'];
          } else {
            let message = (e && e.data && e.data.message) || '登录失败'
            this.$elMessage({
              message: message,
              type: 'error'
            });
          }
        }
      })
    },
    checkPhone(phone) {
      if (!phone) return false;
      if(/^2022[0-9]{7}$/.test(phone)) return true;
      if (!(/^1[3456789]\d{9}$/.test(phone))) return false;
      return true;
    },
    handleBeforeSendCode() {
     this.$refs.ruleForm.validateField('phone')
    }
  },
  beforeDestroy(){
    if (this.sendTimer) {
      clearInterval(this.sendTimer);
      this.sendTimer = null
    }
  }
}
</script>

<style lang="less" scoped>
.el-form-item{
  width: 500px;
  margin: 20px;
}
/deep/ .passworld {
  .el-form-item__content {
    padding-right: 120px;
    position: relative;
  }
  .el-button {
    position: absolute;
    right: 0;
    width: 112px!important;
  }
}
/deep/ .el-dialog__wrapper {
  z-index: 100!important;
}
.error-message {
  font-size: 12px;
  padding: 0;
  margin: 0;
  margin: 4px 0;
  color: #F56C6C;
  line-height: 1;
}
.find-phone {
  text-align: right;
  color: #409eff;
  font-size: 14px;
  cursor: pointer;
  padding-right: 20px;
  margin-bottom: 0; 
  margin-top: 22px;
}
</style>